<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="row mt-5">
          <div class="ml-3">
            <div class="form-label-group">
              <input
                type="text"
                id="userId"
                class="form-control"
                placeholder="მომხმარებელი"
                v-model="charge.userId"
              />
              <label for="userId">მომხმარებელი</label>
            </div>
          </div>
          <div class="form-label-group ml-3">
            <input
              type="text"
              id="prodid"
              class="form-control"
              placeholder="მთავარი პარტნიორის id"
              v-model="charge.partnerId"
            />
            <label for="prodid">მთავარი პარტნიორის id</label>
          </div>
          <div class="form-label-group ml-3">
            <input
              type="text"
              id="amount"
              class="form-control"
              placeholder="ფასი"
              v-model="charge.amount"
            />
            <label for="amount">ფასი</label>
          </div>
          <div
            class="form-label-group ml-3"
            style="width: 100px; padding-left: 10px"
          >
            <input
              type="checkbox"
              class="form-check-input"
              id="statusAdd"
              v-model="charge.addInDebt"
            />
            <label class="form-check-label" for="statusAdd"
              >ერთ-ერთ პარტნიორზე ვერ შეძლოს ჩამოჭრა</label
            >
          </div>
          <div class="form-label-group ml-3">
            <i
              class="fa fa-plus-circle addNewBtn mt-1 ml-4"
              title="დამატება"
              data-toggle="modal"
              data-target="#exampleModalLong"
              @click="addCharge()"
            ></i>
          </div>
        </div>
      </div>
    </div>
    <div id="no-more-tables">
      <table
        class="col-md-12 table-bordered table-striped table-condensed cf mt-5"
      >
        <thead class="cf" style="border-style: none">
          <tr>
            <th class="numeric">მოქმედება</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="heading"
            v-for="valueLegalBrand in resultArray"
            :key="valueLegalBrand.id"
          >
            <td data-title="მოქმედება" style="white-space: normal">
              <div v-html="valueLegalBrand.value"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      class="modal fade bd-example-modal-lg"
      id="exampleModalLongDelete"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    ></div>
  </div>
</template>
<script>
import "../../assets/js/sb-admin.min.js";
import "../../assets/vendor/datatables/jquery.dataTables.js";
import "../../assets/vendor/datatables/dataTables.bootstrap4.js";
import "../../assets/js/demo/datatables-demo.js";
import { bus } from "../common/bus";
import { required } from "vuelidate/lib/validators";

export default {
  name: "products",
  data() {
    return {
      showModal: false,
      charge: {
        userId: null,
        partnerId: "dbc51a75-b0df-41d2-a84d-08dbd9f24e17",
        amount: null,
        addInDebt: false,
      },
      resultArray: [],
    };
  },
  async created() {
    let result = await this.$http.getChargeOperations();
    this.resultArray = result.data.res;
  },
  methods: {
    async addCharge() {
      try {
        let addObject = {
          UserId: this.charge.userId,
          PartnerId: this.charge.partnerId,
          Amount: this.charge.amount,
          AddInDebt: this.charge.addInDebt,
        };

        let result = await this.$http.addChargeOperation(addObject);

        console.log("result", result);

        if (result.data.status == "200") {
          bus.$emit("success", "დაემატა");
        } else {
          bus.$emit("warning", result.data.message);
        }
      } catch (error) {
        bus.$emit("warning", error);
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
@import "../../assets/scss/_mixins.scss";
@import "../../assets/scss/_navbar.scss";
@import "../../assets/scss/sb-admin.scss";
@import "../../assets/css/sb-admin.css";
@import "../../assets/vendor/datatables/dataTables.bootstrap4.css";
@import "../../assets/scss/_login.scss";
@import "../../assets/scss/_global.scss";
</style>



// WEBPACK FOOTER //
// src/components/view/ChargeOperation.vue